import { IArtistMutation, IArtistMutationForm } from 'services/artists/types';

export const artistFormToQuery = (
  artistForm: IArtistMutationForm
): IArtistMutation => {
  const {
    id,
    profilePictureLink,
    profilePicturePreviewLink,
    file,
    isBandOption,
    externalProfiles,
    mainImageId,
    ...artist
  } = artistForm;

  return {
    ...artist,
    artistsInBand: artistForm.isBand
      ? artistForm.artistsInBand.map(artist => artist.value)
      : null,
    phoneNumber: artistForm.phoneNumber?.number
      ? {
          ...artistForm.phoneNumber,
          number: `${artistForm.phoneNumber.number}`,
        }
      : null,
    labelId: artistForm.labelId?.length ? artistForm.labelId : null,
    labelName: artistForm.labelId?.length ? artistForm.labelName : null,
    externalIds: artistForm.externalProfiles,
    mainImageId: mainImageId || undefined
  };
};
